<template>
  <div>
    <vs-prompt
      title="Edit cookie"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row v-if="cookie">
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" disabled v-model="cookie.name" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vendor</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input class="inputx w-full" v-model="cookie.vendor" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Purpose (DK)</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-textarea
                placeholder="Text message"
                v-model="cookie.purpose_dk"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Purpose (EN)</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-textarea
                placeholder="Text message"
                v-model="cookie.purpose_en"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Category</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select v-model="cookie.category">
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in categories"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Method</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select v-model="cookie.method">
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in methods"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Type</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select v-model="cookie.type">
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item"
                  v-for="(item, index) in types"
                />
              </vs-select>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Expiry</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input-number
                min="0"
                v-model="cookie.expiry_seconds"
                label="Seconds"
                style="width: 150px"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: ["cookie"],
  data() {
    return {
      prompt: false,
    };
  },

  methods: {
    show() {
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      await this.$store.dispatch("cookies/update", this.cookie);

      this.$vs.notify({
        color: "success",
        title: `Cookie updated`,
        text: "Cookie updated",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
  computed: {
    validForm() {
      return true;
    },
    ...mapGetters({
      categories: "cookies/categories",
      types: "cookies/types",
      methods: "cookies/methods",
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
